import { checkGraphResponse, getSessionForAccessInfo } from "./GraphMain";
import { getWorkbookChartsBatch } from "./graphChartFunctions";
import { getNamesValueBatch } from "./graphRangeFunctions";
import { accessInfoType, fileInfoType, documentInfoType } from "../utils/classInfos";
import { getNormalizedElementTypeId } from "../utils/helper";
import { getSheetNameFromAddress, getIsSingleCellFromAddress } from "../utils/helperExcel";
import { getAppInfoFromWorkbook } from "./graphAppInfoWorkbookFunctions";
import { getWorksheetUrlSection } from "./helper";


export async function getWorkbookFullInfo(accessInfo: accessInfoType, chartDetailsReadyCallback: any) {
  if (!accessInfo) return;
  
  try {
    const {client, sessionId, fileUrl} = await getSessionForAccessInfo(accessInfo);
    const driveItemId = accessInfo.driveItemInfo.driveItemId;
    // something wrong with the access rights
    if (!sessionId || !client) {
      console.log("ERROR client is null", accessInfo);
      return null;
    }
  
    let tables = [];
    let ranges = [];
    let tempRanges;
    let workSheets = [];
    let helperTables = [];
    let elements = [];
    let fileInfo: fileInfoType;

    const $batch = {
      requests: [
        {
          url: fileUrl, // + "?$select=name,webUrl,size,lastModifiedDateTime",
          method: "GET",
          id: "INFO",
          headers: {
            "workbook-session-id": sessionId
          }
        },
        {
          url: fileUrl + "/workbook/worksheets",
          method: "GET",
          id: "WORKSHEETS",
          headers: {
            "workbook-session-id": sessionId
          }
        },
        {
          url: fileUrl + "/workbook/names",
          method: "GET",
          id: "NAMES",
          headers: {
            "workbook-session-id": sessionId
          }
        },
        {
          url: fileUrl + "/workbook/tables?$name,id,value",
          method: "GET",
          id: "TABLES",
          headers: {
            "workbook-session-id": sessionId
          }
        },
      ],
    };
    // run the batch
    console.time('TTT getWorkbookFullInfo batch');

    let res = await client
      .api("/$batch")
      .post($batch);

    checkGraphResponse(res, "getWorkbookFullInfo");

    console.timeEnd('TTT getWorkbookFullInfo batch');

    //===========================
    // get the FILE INFO
    //===========================

    let tempFileInfo = res.responses[res.responses.findIndex((x) => x.id === "INFO")];
    if (checkGraphResponse(tempFileInfo, "getWorkbookFullInfo.fileInfo")) {
      fileInfo = {
        id: driveItemId,
        name: tempFileInfo.body.name,
        size: tempFileInfo.body.size,
        lastModified: tempFileInfo.body.lastModifiedDateTime,
        webUrl: tempFileInfo.body.webUrl,
        downloadUrl: tempFileInfo.body["@microsoft.graph.downloadUrl"]
      };
    }

    //===========================
    // get the TABLES list
    //===========================

    // get the helper tables list
    let tempTables = res.responses[res.responses.findIndex((x) => x.id === "TABLES")];
    if (checkGraphResponse(tempTables, "getWorkbookFullInfo.tables")) {
      tempTables.body.value?.forEach((tempTable) => {
        if (tempTable.name.includes("AR_")) {
          helperTables.push(tempTable.name);
        }
      })
    }
    let hasHelperTables = helperTables.length > 0;
    // get the app info
    let appInfo = await getAppInfoFromWorkbook(fileUrl, sessionId, client, helperTables);

    appInfo.views && appInfo.views.forEach((item) => {
      elements.push({
        id: item.elementId,
        type: "view",
        name: item.name
      })
    })
    appInfo.calculations && appInfo.calculations.forEach((item) => {
      elements.push({
        id: item.elementId,
        type: "calculation",
        name: item.name
      })
    })

    if (checkGraphResponse(tempTables, "getWorkbookFullInfo.tables2")) {
      tempTables.body.value?.forEach((tempTable) => {
        if (!tempTable.name.includes("AR_")) {
          tables.push({
            id: tempTable.id,
            elementId: getNormalizedElementTypeId(tempTable.id, "table"),
            name: tempTable.name,
            fulltext: "table, " + tempTable.name,
            value: tempTable.value,
            type: "table",
          });
          // elements
          elements.push({
            id: tempTable.id,
            type: "table",
            name: tempTable.name
          })
        }
      })
    }

    //===========================
    // get the NAMES list
    //===========================

    let tempNames = res.responses[res.responses.findIndex((x) => x.id === "NAMES")];
    if (checkGraphResponse(tempNames, "getWorkbookFullInfo.names")) {
      tempNames.body.value?.forEach((tempName) => {
        // look for collaboration
        const elementId = tempName.name.toLowerCase();
        const elementType = tempName.type.toLowerCase();

        if (elementType === "range") {
          // sheet name
          const worksheetName = getSheetNameFromAddress(tempName.value).toLowerCase().replaceAll("'", "");
          const isCell = getIsSingleCellFromAddress(tempName.value);
          ranges.push({
            id: elementId,
            elementId: getNormalizedElementTypeId(elementId, "range"),
            name: tempName.comment || tempName.name,
            fulltext: "range," + tempName.name,
            value: tempName.value,
            isCell: isCell,
            scope: tempName.scope,
            worksheet: worksheetName, //getSafeWorksheetName(tempName.value), //worksheetName,
            type: "range",
            visible: tempName.visible,
          });
        }
      });
    };  

    //===========================
    // get the WORKSHEET list
    //===========================

    let tempWorkSheets = res.responses[res.responses.findIndex((x) => x.id === "WORKSHEETS")];
    if (checkGraphResponse(tempWorkSheets, "getWorkbookFullInfo.worksheets")) {
      tempWorkSheets.body.value?.forEach((tempWorksheet) => {
        // look for collaboration
        const elementId = tempWorksheet.id;
        const elementName = tempWorksheet.name;
        if (!elementName.includes("AR_")) {
          let rangesInWorksheet = [];
          // get the names for this worksheet
          ranges.forEach(name => {
            if (name.worksheet === tempWorksheet.name.toLowerCase()) {
              rangesInWorksheet.push({ "id": name.id, "name": name.name});
              name.worksheetId = elementId;
            }
          })
          workSheets.push({
            id: elementId,
            elementId: getNormalizedElementTypeId(elementId, "sheet"),
            name: tempWorksheet.name,
            fulltext: "sheet, " + tempWorksheet.name,
            visible: tempWorksheet.visibility === "Visible",
            position: tempWorksheet.position,
            ranges: rangesInWorksheet,
            type: "sheet",
          });
          // elements
          elements.push({
            id: elementId,
            type: "sheet",
            name: tempWorksheet.name,
          })
        }
      })
    }

    // get the cellValues for cells
    tempRanges = await getNamesValueBatch(
      fileUrl,
      sessionId,
      client,
      ranges
    );


    tempRanges && tempRanges.items.forEach(range => {
      // elements
      elements.push({
        id: range.elementId,
        type: "range",
        isCell: range.isCell,
        name: range.name,
        value: range.value,
        worksheet: range.worksheet,
        worksheetId: range.worksheetId
      })
    })

    //===========================
    // get the CHARTS list
    //===========================

    console.time('TTT getWorkbookFullInfo charts');

    let tempCharts = [];
    try {
      // get the charts from all the worksheets
      tempCharts = await getWorkbookChartsBatch(
        client,
        accessInfo,
        workSheets,
        sessionId,
        chartDetailsReadyCallback //detail callback
      );
      tempCharts.forEach(chart => {
        const elementId = chart.id;
        // elements
        elements.push({
          id: elementId,
          type: "chart",
          name: chart.caption,
          worksheetId: chart.worksheetId
        })
      })
    } catch (err) {
      console.log("ERROR getCharts", err)
    }
    console.timeEnd('TTT getWorkbookFullInfo charts');

    // THE RESULT
    
    let documentInfo: documentInfoType = {
      fileInfo,
      accessInfo,
      appInfo,
      charts: tempCharts,
      tables,
      ranges: tempRanges?.items,
      workSheets,
      elements,
      hasHelperTables
    }
    return documentInfo;
  } catch (err) {
    console.log("ERROR getWorkbookFullInfo", err);
    return null;
  }
}

export async function getWorkbookFileInfo(accessInfo: accessInfoType) {
  if (!accessInfo) return;
  
  try {
    const {client, sessionId, fileUrl} = await getSessionForAccessInfo(accessInfo);
    const driveItemId = accessInfo.driveItemInfo.driveItemId;
    // something wrong with the access rights
    if (!sessionId || !client) {
      console.log("ERROR client is null", accessInfo);
      return null;
    }
  
    let fileInfo: fileInfoType;

    const $batch = {
      requests: [
        {
          url: fileUrl,
          method: "GET",
          id: "INFO",
          headers: {
            "workbook-session-id": sessionId
          }
        },
      ],
    };
    // run the batch
    let res = await client
      .api("/$batch")
      .post($batch);

    checkGraphResponse(res, "getWorkbookFileInfo");

    //===========================
    // get the FILE INFO
    //===========================

    let tempFileInfo = res.responses[res.responses.findIndex((x) => x.id === "INFO")];
    if (checkGraphResponse(tempFileInfo, "getWorkbookFileInfo.fileInfo")) {
      fileInfo = {
        id: driveItemId,
        name: tempFileInfo.body.name,
        size: tempFileInfo.body.size,
        lastModified: tempFileInfo.body.lastModifiedDateTime,
        webUrl: tempFileInfo.body.webUrl,
        downloadUrl: tempFileInfo.body["@microsoft.graph.downloadUrl"]
      };
    }

    // THE RESULT
    return fileInfo;
  } catch (err) {
    console.log("ERROR getWorkbookFileInfo", err);
    return null;
  }
}

export async function getDocumentItemsForCalculations(accessInfo: accessInfoType) {
  
  try {
    const {client, sessionId, fileUrl} = await getSessionForAccessInfo(accessInfo);
    // something wrong with the access rights
    if (!sessionId) {
      return null;
    }
    let workSheets = [];
    let charts = [];
    // worksheets
    const workSheetsRes = await client.api(fileUrl + "/workbook/worksheets")
      .get()
    workSheetsRes.value?.forEach((worksheet) => {
      workSheets.push({
        id: worksheet.id,
        type: "worksheet",
        name: worksheet.name
      })
    })
    // charts
    const worksheetChartsRes = await getWorkbookChartsBatch(client, accessInfo, workSheets, sessionId, null);
    worksheetChartsRes.forEach((chart) => {
      charts.push({
        id: chart.id,
        type: "chart",
        name: chart.name,
        height: chart.height,
        width: chart.width,
        thumbnail: chart.thumbnail,
        worksheet: chart.worksheet,
        worksheetId: chart.worksheetId
      })
    })

  return( {
      worksheets: workSheets,
      charts: charts
    });
  } catch (err) {
    console.log("ERROR getDocumentItems", err);
  }
};

export async function getWorkbookDataAsJson(
  accessInfo: accessInfoType,
  worksheetList: String[]
) {
  const sessionInfo  = await getSessionForAccessInfo(accessInfo);
  // check the info
  if (!sessionInfo || !sessionInfo.sessionId) return null;
  const {client, sessionId, fileUrl} = sessionInfo;

  let $batch = {
    requests: [
      {
        url: fileUrl + "/workbook/worksheets",
        method: "GET",
        id: "WORKSHEETS",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: fileUrl + "/workbook/names?$select=name,type,value",
        method: "GET",
        id: "NAMES",
        headers: {
          "workbook-session-id": sessionId
        }
      },
    ],
  };
  // RUN BATCH
  let res = await client
    .api("/$batch")
    .post($batch);

  checkGraphResponse(res, "getSheetUsedRange");

  let resWorksheets = res.responses[res.responses.findIndex((x) => x.id === "WORKSHEETS")]?.body;
  if (!resWorksheets) return null;

  // get the names
  let resNames = res.responses[res.responses.findIndex((x) => x.id === "NAMES")]?.body;
  let names = [];
  resNames?.value?.forEach((item, index) => {
    names.push({
      name: item.name,
      type: "name",
      subType: item.type,
      address: item.value
    })
  })

  let requests = [];
  let workbookData = [];

  resWorksheets.value?.forEach((tempWorksheet, index) => {
    // look for collaboration
    const worksheetName = tempWorksheet.name;
    const worksheetId = tempWorksheet.id;
    let shouldGetData = !worksheetName.includes("AR_");
    if (worksheetList && worksheetList.length > 0) {
      shouldGetData = worksheetList.includes(worksheetId);
    }

    

    if (shouldGetData) {
      const worksheetUrl = fileUrl + "/workbook/" + getWorksheetUrlSection(worksheetId) + "/usedRange(valuesOnly=true)?$select=formulas,address,cellCount";
      // return record
      workbookData.push(
        {
          index: index,
          worksheetId: worksheetId,
          type: "worksheet",
          name: worksheetName,
        }
      )
      // request for more detail
      requests.push(
        {
          url: worksheetUrl,
          method: "GET",
          id: String(index),
          headers: {
            "workbook-session-id": sessionId
          }
        }
      )
    }
  })

  if (requests.length > 0) {
    let $batchDetails = {
      requests: requests,
    };
    // RUN BATCH
    let resDetails = await client
      .api("/$batch")
      .post($batchDetails);
  
    workbookData.forEach((worksheet, index) => {
      let data = resDetails.responses[resDetails.responses.findIndex((x) => x.id === String(worksheet.index))]?.body;
      worksheet.data = data?.formulas;
      worksheet.address = data?.address;
      worksheet.cellCount = data?.cellCount;
    })

  }

  // RESULTS

  return { worksheets: workbookData, names: names };
}